// extracted by mini-css-extract-plugin
export default {"container":"Habit_container__MHpwg"};